<template>
  <v-app-bar
    app
    clipped-left
    height="72px"
    class="app-bar"
  >
    <!-- ハンバーガーアイコン -->
    <v-menu-icon/>

    <!-- ロゴ画像 -->
    <p class="header-logo">
      <router-link :to="homePath">
        <img src="@/assets/img/header_logo.png" width=200 height="50" alt="ゲットスルー2600">
      </router-link>
    </p>

  </v-app-bar>
</template>


<script>
import VMenuIcon from '@/components/atoms/MenuIcon'
export default {
  components: {
    VMenuIcon
  },

  computed: {
    homePath() {
      return this.$store.getters['user/homePath']
    }
  },
}
</script>

<style lang="stylus" scoped>
.header-logo
  margin: 0px;
  margin-bottom: 5px;
  position: relative;
  left: 50%;
  top: 50%;
  transform: translate(-50%, -50%);
</style>
